import React from 'react'
//import I18n from "i18n-js/index.js.erb"
export default class ReservationBuilderSuccessStep extends React.Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    if (window && window.top && window.top.refreshSystemNotificationsBadgeNumber) {
      window.top.refreshSystemNotificationsBadgeNumber();
    }
  }

  render() {
    return (
      <div className="jumbotron">
          <h2 className="text-center"><strong>{I18n.t('reservation_created')}!</strong></h2>
          <p className="text-center">{I18n.t('confirmation')}: {this.props.reservation.confirmation_number}</p>
      </div>
    );
  }

};